<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M12.625 16.75C10.3468 16.75 8.5 15.071 8.5 13C8.5 10.929 10.3468 9.25 12.625 9.25C14.9032 9.25 16.75 10.929 16.75 13C16.75 13.6057 16.5921 14.178 16.3115 14.6844C16.0918 15.081 15.9476 15.5355 16.0871 15.9669C16.1482 16.1558 16.2173 16.3429 16.2917 16.5294C15.9231 16.5075 15.5685 16.4638 15.2232 16.3974C14.8545 16.3265 14.4732 16.3713 14.1192 16.4964C13.6559 16.6601 13.152 16.75 12.625 16.75Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.6095 7C13.0626 4.84998 10.9825 3.25 8.5 3.25C5.60051 3.25 3.25 5.43261 3.25 8.125C3.25 8.99027 3.49276 9.8029 3.91848 10.5073C4.14909 10.8889 4.2835 11.3366 4.15951 11.7648C4.06703 12.0842 3.95588 12.3995 3.83334 12.7132C4.43332 12.6768 5.0043 12.594 5.55832 12.4625C5.78963 12.4076 6.03249 12.435 6.25 12.5309" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'DocsGPTIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>